import React from 'react';
import { FaTwitter, FaGithub, FaDiscord } from 'react-icons/fa';

const HeroSection = () => (
  <section className="hero-text-container">
    <div className="hero-text">
      <h1 className="hero-title">GREENLEND</h1>
      <p className="hero-description">Facilitate peer-to-peer microloans for social and environmental impact projects.</p>
      <div className="hero-icons">
        <a href="https://twitter.com/greenlend" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
        <a href="https://github.com/greenlend" target="_blank" rel="noopener noreferrer"><FaGithub /></a>
        <a href="https://discord.com" target="_blank" rel="noopener noreferrer"><FaDiscord /></a>
      </div>
    </div>
  </section>
);

export default HeroSection;
